/**
 * Regex to filter chatbot message
 */
const chatbotRegex = /(?:\[(api(?:call|response)|button|resend|check|response|image|video|show|option|intent|end session)\] .+(?: \[\/\1\])?|\[end session\])/;
export default chatbotRegex;
